import React from 'react';

import classes from './Header.module.css';

const Header = ({ userEmail, onLogout }) => {
  return (
    <header className={classes.header}>
      <div className={classes.headerLogo}>Allorado Device</div>
      {userEmail && (
        <div className={classes.headerUser}>
          <span className={classes.headerUserEmail}>{userEmail}</span>
          {onLogout && (
            <button className={classes.headerLogout} onClick={onLogout}>
              Log out
            </button>
          )}
        </div>
      )}
    </header>
  );
};

export default Header;


